const setErrorDisplayState = (state: boolean) => {
  const errorElement =
    document.querySelector<HTMLElement>(".faq-search__error");

  if (!errorElement) {
    return;
  }

  errorElement.hidden = !state;
};

export const hideError = () => {
  setErrorDisplayState(false);
};

export const showError = () => {
  setErrorDisplayState(true);
};
